/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../../app/modules/auth'
import { SidebarMenuItem } from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const { currentUser } = useAuth()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='home'
        title='Visão geral'
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem to='/pedidos' title='Pedidos' icon='bi-receipt'
        fontIcon='bi' />
      {/* <SidebarMenuItem to='/pedidos-de-fabrica' title='Pedidos de Fábrica' icon='bi-building'
        fontIcon='bi' /> */}
      <SidebarMenuItem to='/produtos' title='Produtos' icon='element-11'
        fontIcon='bi-layers' />
      <SidebarMenuItem to='/agendamentos' icon='calendar' title='Agenda' fontIcon='bi-layers' />
      {/* <SidebarMenuItem to='/builder' icon='graph-2' title='Relatórios' fontIcon='bi-layers' /> */}
      <SidebarMenuItem to='/usuarios' icon='profile-circle' title='Usuários' fontIcon='bi-layers' />
      <SidebarMenuItem to='/clientes' icon='bi-people-fill' title='Clientes' fontIcon='bi' />
      <SidebarMenuItem to='/comissoes' icon='bi-percent' title='Comissões' fontIcon='bi' />
      {currentUser?.s_tipo === 'AM' && <SidebarMenuItem to='/marmorarias' icon='bi-buildings' title='Marmorarias' fontIcon='bi' />}
      <SidebarMenuItem to='/empresa' icon='bi-gear' title='Empresa' fontIcon='bi' />
      {currentUser?.s_tipo === 'AM' && <SidebarMenuItem to='/financas' icon='bi-currency-dollar' title='Finanças' fontIcon='bi' />}
      <SidebarMenuItem to='/renovacao' icon='bi-currency-dollar' title='Licença' fontIcon='bi' />
    </>
  )
}

export { SidebarMenuMain }

